<template>
  <div>
    <v-radio-group row v-model="payload.視力" class="justify-space-around">
      <v-radio label="裸視" value="裸視"></v-radio>
      <v-radio label="矯正" value="矯正"></v-radio>
    </v-radio-group>
    <d-input
      class="mt-4 text-h6"
      v-model.number="payload.左眼"
      :label="`左眼${payload.視力}`"
      max="2"
      :option="{ suffix: '' }"
    ></d-input>
    <d-input
      class="mt-4 text-h6"
      v-model.number="payload.右眼"
      :label="`右眼${payload.視力}`"
      max="2"
      :option="{ suffix: '' }"
    ></d-input>

    <v-btn block x-large class="mt-4 text-h6" color="success" @click="submit"
      >送出</v-btn
    >
    <v-btn block x-large class="mt-8 text-h6" color="error" @click="back"
      >取消</v-btn
    >
  </div>
</template>

<script>
import station from "@/mixins/station";
export default {
  mixins: [station],
  data: () => ({
    payload: {
      視力: "裸視",
      左眼: null,
      右眼: null,
    },
  }),
};
</script>

<style lang="scss" scoped>
::v-deep .v-input--radio-group__input {
  justify-content: center;
  .v-radio {
    padding: 0 16px;
  }
  .v-icon.v-icon {
    font-size: 2rem;
  }
  label {
    font-size: 1.25rem;
  }
}
</style>
